import { useRoutes, useNavigate, type NavigateFunction } from 'react-router-dom';
import { Suspense, useEffect } from 'react';
import routes from './config';

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();
  
  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver(window.REACT_APP_NAVIGATE);
  }, [navigate]);
  
  return (
    <Suspense
      fallback={
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
          <div className="text-center">
            <i className="ri-loader-4-line text-5xl text-teal-600 animate-spin"></i>
            <p className="mt-4 text-gray-600 dark:text-gray-400 text-lg">Carregando...</p>
          </div>
        </div>
      }
    >
      {element}
    </Suspense>
  );
}
